<template>
  <div class="container">
    <div v-if="$route.params.mje == 'error-reintentos-biometria'">
      <img
        class="veridas-icon"
        src="@/assets/img/1x/biometric_dark.svg"
        alt="Ícono biometría"
      />
      <p class="nombre medium">Validá tu identidad al recibir la tarjeta</p>
      <div class="mensaje-wrapper">
        <span v-safe-html="error.text"></span>
      </div>
    </div>

    <div v-else-if="$route.params.mje == 'error-veridas-ca'">
      <img
        class="veridas-icon"
        src="@/assets/img/1x/facial_recognition_error.svg"
        alt="Ícono error"
      />
      <p class="nombre medium">No pudimos verificar tu información</p>
      <div class="mensaje-wrapper">
        <span v-safe-html="error.text"></span>
      </div>
    </div>

    <div v-else>
      <img
        class="veridas-icon"
        src="@/assets/img/1x/facial_recognition_error.svg"
        alt="Ícono error"
      />
      <p class="nombre medium">No pudimos verificar tu identidad</p>
      <div class="mensaje-wrapper">
        <span v-safe-html="error.text"></span>
      </div>
    </div>

    <div
      v-if="
        $route.params.mje == 'error-reintentos-biometria' ||
          $route.params.mje == 'error-memoria-veridas'
      "
      class="button-container"
    >
      <sales-button
        color="#1973B8"
        @click.native="goPresential"
        class="sales-button"
        label="Continuar"
        analyticsName="continuar"
        analyticsModule="identidad"
        analyticsSubmodule="error veridas result"
      />
    </div>
    <div
      v-if="
        $route.params.mje == 'error-tokenExpired' ||
          $route.params.mje == 'error-dni'
      "
      class="button-container"
    >
      <sales-button
        color="#1973B8"
        @click.native="goBack"
        class="sales-button"
        label="Reintentar"
        analyticsName="reintentar"
        analyticsModule="identidad"
        analyticsSubmodule="error dni"
      />
    </div>
    <div
      v-if="$route.params.mje == 'error-veridas-ca'"
      class="button-container"
    >
      <sales-button
        color="#1973B8"
        @click.native="goSucursal"
        class="sales-button button-sucursales"
        label="Ver sucursales"
        analyticsName="reintentar"
        analyticsModule="identidad"
        analyticsSubmodule="error veridas ca"
      />
    </div>

    <div v-if="$route.params.mje == 'error-servidor'" class="button-container">
      <sales-button
        color="#1973B8"
        @click.native="goBack"
        class="sales-button"
        label="Aceptar"
      />
    </div>

    <div
      v-if="
        $route.params.mje != 'error-memoria-veridas' &&
          $route.params.mje != 'error-reintentos-biometria' &&
          $route.params.mje !== 'error-tokenExpired' &&
          $route.params.mje !== 'error-dni' &&
          $route.params.mje !== 'error-veridas-ca' &&
          $route.params.mje !== 'error-servidor'
      "
      class="button-container"
    >
      <sales-button
        color="#1973B8"
        @click.native="goBack"
        class="sales-button"
        label="Reintentar"
        analyticsName="reintentar"
        analyticsModule="identidad"
        analyticsSubmodule="error veridas result"
      />
    </div>
  </div>
</template>

<script>
import errores from "@/config/constants/errores";
import SalesButton from "@/components/core/SalesButton";
import * as MUTATIONS from "@/config/constants/mutation-types";
export default {
  name: "MensajeVeridas",
  components: { SalesButton },
  computed: {
    error() {
      return errores[this.$route.params.mje];
    }
  },
  methods: {
    goPresential() {
      let model = this.$store.getters.getIdentidad();
      model.isDigital = false;
      model.isPresencial = true;
      model.isPresencialVoluntario = false;
      this.$config.values.json.cantPasos = 6;
      this.$store.dispatch("doPresencial", model);
    },
    goBack() {
      this.$store.dispatch(
        "doClickCTA",
        "reintentar error motor online biometria"
      );

      this.$store.commit(MUTATIONS.RESET_DVS_IFRAME_DATA);

      if (this.$route.params.mje == "error-servidor") {
        this.$router.push("/");
        return;
      }
      this.$router.push("/identidad");
    },
    goSucursal() {
      window.location.href =
        "https://buscador.bbva.com.ar/buscadordecajerosysucursales/";
    }
  }
};
</script>

<style scoped>
.veridas-icon {
  width: 150px;
  place-self: center;
  display: flex;
  margin-left: auto;
  margin-right: auto;
}
.container {
  padding: 20px;
  width: auto;
  padding-top: 80px;
  text-align: center;
}
.container.sales-button {
  height: 56px;
  width: 150px;
}
.container.button-sucursales {
  width: 170px;
}

p.nombre {
  font-size: 28px;
  margin-bottom: 45px;
  margin-bottom: 32px;
}

.mensaje-wrapper {
  color: #121212;
  font-size: 18px;
}

.button-container {
  margin-top: 30px;
  text-align: center;
}

@media screen and (max-width: 600px) {
  .container {
    margin-top: 0;
    margin-bottom: 100px;
  }
}

@media screen and (min-width: 600px) {
  .container {
    margin-top: 0;
    margin-bottom: 90px;
  }
}
</style>
